import ToolbarDropdown from '@/components/TiptapEditor/Toolbar/Dropdowns/ToolbarDropdown';
import { InputAdornment } from '@mui/material';
import BorderStyleIcon from '@mui/icons-material/BorderStyle';
import { findParentNode, useCurrentEditor, useEditorState } from '@tiptap/react';
import React, { useMemo, useState } from 'react';

const BorderWidthSelect = React.forwardRef(({ nodeType = 'table' }, ref) => {
	const { editor } = useCurrentEditor();

	const { borderWidth, borderStyle } = useEditorState({
		editor,
		selector: (ctx) => {
			const selection = ctx.editor?.state?.selection;
			const currentCell = findParentNode((node) =>
				(nodeType === 'table' ? ['tableHeader', 'tableCell'] : [nodeType]).includes(
					node.type.name
				)
			)(selection);

			return {
				borderWidth: currentCell?.node?.attrs?.borderWidth,
				borderStyle: currentCell?.node?.attrs?.borderStyle,
				currentSelection: selection,
				currentCell,
			};
		},
	});

	const options = useMemo(
		() =>
			[1, 2, 3, 4, 5].map((key) => ({
				label: `${key}px`,
				value: `${key}px`,
				type: 'borderWidth',
				style: borderStyle,
				default: '1px',
			})),
		[borderStyle]
	);

	const handleChange = (e) => {
		if (nodeType === 'table') {
			editor.chain().focus().setCellAttribute('borderWidth', e.target.value).run();
		} else {
			editor.chain().focus().setDivAttribute('borderWidth', e.target.value).run();
		}
	};

	return (
		<ToolbarDropdown
			ref={ref}
			title='Border width'
			showSelection={true}
			defaultValue={borderWidth}
			fields={options}
			onChange={handleChange}
			sx={{
				width: '70px',
				pl: '4px',
			}}
		/>
	);
});
BorderWidthSelect.displayName = 'BorderWidthSelect';
export default BorderWidthSelect;
